import { useTranslation } from 'react-i18next'

import { GiftIcon } from '@phosphor-icons/react'

import AnimatedNumber from '@/common/components/AnimatedNumber/AnimatedNumber'
import { statisticStatuses } from '@/common/components/Statistic/constants'
import Statistic from '@/common/components/Statistic/Statistic'

const EarningsRetainedAsStoreCredit = ({
  earningsRetainedAsStoreCredit,
  earningsRetainedAsGiftCard,
  giftCardAllowed,
  storeCreditAllowed,
  currency,
}) => {
  const { t } = useTranslation()

  const getName = () => {
    if (giftCardAllowed && storeCreditAllowed) {
      return t('Ingresos retenidos en crédito en tienda/tarjetas regalo')
    } else if (giftCardAllowed) {
      return t('Ingresos retenidos en tarjetas regalo')
    } else {
      return t('Ingresos retenidos en crédito en tienda')
    }
  }

  const getAmount = () => {
    if (giftCardAllowed && storeCreditAllowed && earningsRetainedAsGiftCard && earningsRetainedAsStoreCredit) {
      return Number(earningsRetainedAsStoreCredit) + Number(earningsRetainedAsGiftCard)
    } else if (giftCardAllowed && earningsRetainedAsGiftCard) {
      return Number(earningsRetainedAsGiftCard)
    } else if (storeCreditAllowed && earningsRetainedAsStoreCredit) {
      return Number(earningsRetainedAsStoreCredit)
    }
  }

  const amount = getAmount()

  return (
    <Statistic
      size="small"
      isOutlined={false}
      status={statisticStatuses.success}
      Icon={GiftIcon}
      label={t(getName())}
      value={<AnimatedNumber target={amount} format="currency" currency={currency} />}
    />
  )
}

export default EarningsRetainedAsStoreCredit
